import { Container } from "../components/container";

export function Testimony() {
  return (
    <Container
      className="min-h-dvh flex flex-col justify-center items-center !mx-auto !max-w-lg leading-[1.3] pt-[195px]"
      id="testimony"
    >
      <p className="text-center">
        <strong>East landscape:s</strong> löfte är att vara aktiv i det öppna
        diskussionsforumet och genom sin arkitektur visa på hur man kan förena
        dessa tre pelare för att skapa hållbar, jämställd och vackert grönskande
        landskapsarkitektur.
      </p>
      <p className="text-center font-[agency-fb] mt-8 underline">
        <a
          href="https://arkitekten.se/debatt/alla-barn-ska-ha-en-plats-i-leklandskapet/"
          rel="noreferrer"
          target="_blank"
        >
          Alla barn ska ha en plats i leklandskapet
        </a>
      </p>
    </Container>
  );
}
